import { toLabeledValues as to } from '../../../utils/labeledValues'
import {
  ConstructionAdminSubmittal,
  FromLabeledValuesValue,
  ReportOption,
} from './types'
import { SEPARATOR } from '../../types'
import { DefaultOptionType } from '../../../types'
import { Report } from '@cims-online/shared'
import { errorHandler } from 'hooks/errorHandler'

export function toLabeledValues(items: ReportOption[] | undefined | null) {
  return to(items, {
    type: 'callback',
    callback: (item) => {
      let label, tooltip
      if (item.__typename === 'AsphaltLot') {
        label = item.asphaltLotId
        tooltip = Report.AsphaltLot.classTypeName
      } else if (item.__typename === 'ConstructionAdminSubmittal') {
        label = item.packageNumber
        tooltip = Report.ConstructionAdminSubmittal.classTypeName
      } else if (item.__typename === 'ConcretePlacement') {
        label = item.placementId
        tooltip = Report.ConcretePlacementCoreSheet.classTypeName
      } else if (item.__typename === 'ConcreteTest') {
        label = item.fieldNumber
        tooltip = Report.ConcreteCylinderIASheet.classTypeName
      } else if (item.__typename === 'ConcreteTestSet') {
        label = item.testSetId
        tooltip = Report.ConcreteTestSet.classTypeName
      } else if (item.__typename === 'DailyInspectionControlPoint') {
        label = item.controlPointId
        tooltip = Report.ControlPoint.classTypeName
      } else if (item.__typename === 'DailyInspectionInspection') {
        label = item.inspectionId
        tooltip = Report.Inspection.classTypeName
      } else if (item.__typename === 'DailyInspectionPunchList') {
        label = item.punchListId
        tooltip = Report.PunchList.classTypeName
      } else if (item.__typename === 'Lot') {
        label = item.lotId
        tooltip = Report.DensityLot.classTypeName
      }
      return { label: label ?? getId(item), value: join(item), tooltip }
    },
  })
}

function failedToSplit(reason: string) {
  return errorHandler(`Failed to split report record select value: ${reason}`)
}

export function split(
  value: DefaultOptionType['value']
): FromLabeledValuesValue {
  const [typename, reportId] = value?.toString().split(SEPARATOR) ?? []
  if (!typename) throw failedToSplit('typename is undefined')
  if (!reportId) throw failedToSplit('reportId is undefined')
  /**
   * this "clever" solution takes inspiration from a stack overflow [answer](https://stackoverflow.com/a/78978643)
   *
   * i'm doing it to enforce any additional report options that show up later
   */
  const typenames: Record<ReportOption['__typename'], 1> = {
    AsphaltLot: 1,
    ConcretePlacement: 1,
    ConcreteTest: 1,
    ConcreteTestSet: 1,
    ConstructionAdminSubmittal: 1,
    DailyInspectionControlPoint: 1,
    DailyInspectionInspection: 1,
    DailyInspectionPunchList: 1,
    Lot: 1,
  }
  const found = typenames[typename as keyof typeof typenames] as 1 | undefined
  if (!found) throw failedToSplit(`invalid typename ${typename}`)
  return { typename: typename as ReportOption['__typename'], reportId }
}

export function join(item: ReportOption) {
  return `${item.__typename}${SEPARATOR}${getId(item)}`
}

function getId(item: ReportOption) {
  if (item.__typename === 'ConstructionAdminSubmittal') return item.id
  return (item as Exclude<ReportOption, ConstructionAdminSubmittal>).globalId
}
